if (!customElements.get('faq-content-toggle')) {
  class FaqContentToggle extends HTMLElement {
    constructor() {
      super();
      window.location.search.includes('faq-content=true')
        ? this.toggleContent(true)
        : this.toggleContent(false);
    }

    toggleContent(show) {
      show
        ? document.body.classList.add('faq-content-open')
        : document.body.classList.remove('faq-content-open');
    }
  }

  window.FaqContentToggle = FaqContentToggle;

  customElements.define('faq-content-toggle', FaqContentToggle);
}



